import { C } from "./theme";

// A category's heading on Fears and Habits: tap to open or close it. `countText` ("3 fears") shows while it's
// closed. `handle` is an optional ⠿ to drag the whole category.
export function GroupHeader({ label, icon, countText, open, onToggle, handle = null }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
      <button onClick={onToggle} aria-expanded={open}
        style={{ flex: 1, minWidth: 0, minHeight: 44, display: "flex", alignItems: "center", gap: 8, background: "none", border: "none", padding: "0 4px", cursor: "pointer", fontFamily: "inherit", textAlign: "left" }}>
        {icon && <span aria-hidden="true" style={{ fontSize: 16, lineHeight: 1 }}>{icon}</span>}
        <span style={{ fontSize: 14, fontWeight: 700, color: C.textMid, letterSpacing: "0.06em", textTransform: "uppercase" }}>{label}</span>
        {!open && <span style={{ fontSize: 14, color: C.textMid }}>{countText}</span>}
        <span aria-hidden="true" style={{ marginLeft: "auto", fontSize: 12, color: C.textMid }}>{open ? "▲" : "▼"}</span>
      </button>
      {handle}
    </div>
  );
}
